import { styled } from 'goober';
import { forwardRef } from 'react';

export const ImportJobLink = styled(
    'div',
    forwardRef
)(({ theme }) => ({
    color: theme.colors.dark.w500,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
        color: theme.colors.primary.w500,
    },
}));

export const FormSeparator = styled('div')<{ $marginVertical?: number }>(({ theme, $marginVertical = 30 }) => ({
    margin: `${$marginVertical}px 0`,
    borderTop: '1px solid',
    borderColor: theme.colors.neutral.w200,
}));
